import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  InjectionToken,
  Input,
  output,
  input,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  positionPairs,
  OverlayPosition,
} from '../../../core/overlay/overlay-directives';
import { DividerComponent } from '../../divider/divider.component';
import { DropdownItemComponent } from '../../dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { RtTooltip } from '../../tooltip/tooltip.directive';
import { IconHelpComponent } from '../icon-help/icon-help.component';
import { IconComponent } from '../icon.component';

export interface IconHelpWithDropdownTranslations {
  clickForHelp: string;
  learnMore: string;
  contactSupport: string;
}

export const IconHelpWithDropdownTranslationsToken =
  new InjectionToken<IconHelpWithDropdownTranslations>('Translations for IconHelpWithDropdown');

@Component({
  selector: 'rt-icon-help-with-dropdown',
  templateUrl: 'icon-help-with-dropdown.component.html',
  styleUrls: ['./icon-help-with-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.with-padding]': 'withPadding()',
    '[class.inline]': 'inline()',
    '(click)': 'toggleDropdown()',
  },
  imports: [
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    IconHelpComponent,
    OverlayOriginDirective,
    RtTooltip,
    TranslatePipe,
    DividerComponent,
  ],
})
export class IconHelpWithDropdownComponent {
  public readonly infoText = input<string>(undefined!);
  public readonly contactSupport = input<boolean>(false);
  public readonly withPadding = input<boolean>(false);
  public readonly inline = input<boolean>(false);
  public readonly positions = input<ConnectionPositionPair[]>([
    positionPairs[OverlayPosition.BottomLeft],
    positionPairs[OverlayPosition.TopLeft],
  ]);
  @Input() public link: string;

  public readMoreClick = output<void>();
  public openIntercom = output<void>();

  public dropdownOpen: boolean = false;

  constructor(
    protected cdRef: ChangeDetectorRef,
    @Inject(IconHelpWithDropdownTranslationsToken)
    public translations: IconHelpWithDropdownTranslations,
  ) {}

  public toggleDropdown(state: boolean | undefined = undefined): void {
    this.dropdownOpen = state === undefined ? !this.dropdownOpen : state;
    this.cdRef.detectChanges();
  }

  public handleLinkClick(): void {
    this.toggleDropdown(false);
    this.readMoreClick.emit();
  }

  public openIntercomChat(): void {
    this.openIntercom.emit();
  }
}
